import {useEffect, useState} from 'react';

/**
 * Forces a component to re-render after it mounts.
 * This is useful for components that depend on refs being set after initial mount,
 * such as popovers that need to calculate their position relative to a target element.
 */
export const useRerenderOnMount = () => {
  const [_rerenderToken, setRerenderToken] = useState(0);
  useEffect(() => {
    setRerenderToken((prev) => prev + 1);
  }, []);
};
